<template>
  <v-container>
    <v-row>
      <v-col cols="12" v-if="fetchStatus === ACTION_STATUS.LOADING" class="text-center">
        <LoadingState loadingText="Cargando evaluaciones. Por favor, espere..." />
      </v-col>
      <v-col cols="12" v-if="fetchStatus === ACTION_STATUS.FAILED" class="text-center">
        <ErrorState errorText="Error al cargar las evaluaciones de desempeño." :retryFunction="onRetry" />
      </v-col>
      <v-col cols="12" v-if="fetchStatus === ACTION_STATUS.SUCCEEDED">
        <slot name="success" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { ACTION_STATUS } from '@src/const'
import LoadingState from '@src/components/common/LoadingState.vue'
import ErrorState from '@src/components/common/ErrorState.vue'

export default {
  components: { LoadingState, ErrorState },

  props: {
    fetchStatus: {
      type: String,
      default: ACTION_STATUS.IDLE,
    },

    onRetry: {
      type: Function,
      default: () => {},
    },
  },

  data() {
    return {
      ACTION_STATUS,
    }
  },
}
</script>
